import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';

const Home = () => {
  const [showHero, setShowHero] = useState(false);

  useEffect(() => {
    // Trigger hero animation after component mounts
    const timer = setTimeout(() => {
      setShowHero(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const testimonials = [
    {
      text: "It has been a wonderful experience with Imperier Holdings as a valuable asset as an investor for Zypp/Mobycy. A great investor not only brings financial resources to the table but also contributes with their expertise, guidance, and network. With Imperier Holdings continued involvement and support, Zypp/Mobycy can look forward to a promising future, building on the strengths of their expertise and dedication.",
      author: "Akash Gupta",
      position: "Co-Founder & CEO at Zypp Electric"
    },
    {
      text: "I highly recommend Imperier Holdings for their unmatched financial expertise and dedication. Their personalized solutions have been instrumental in helping me reach my investment goals, with consistent growth and impressive returns. The team’s commitment to transparency and clear communication has built my trust and confidence in their services. For anyone seeking a professional and results-driven financial partner, Imperier Holdings is the ideal choice.",
      author: "Kishore Kumar Jagwani",
      position: "Investor"
    },
    {
      text: "I am thrilled to share my experience with Imperier, that has been instrument in the growth and success of our startup. Their team immediately grasped our vision and the specific hurdles we faced. Their guidance, expertise, and funding have been indispensable in our growth and expansion. What truly stands out is their unwavering support. We eagerly anticipate the future as we continue our partnership, aiming for even greater milestones together.",
      author: "Sunny Garg",
      position: "CEO - Crib"
    },
    {
      text: "I highly recommend Imperier Holdings as a premier provider of exceptional services for businesses and individuals. Their expertise in investment opportunities, particularly in Startups and the Share Market, is outstanding. They excel in providing comprehensive explanations, confirming their superiority over competitors.",
      author: "Rahul Gurnani",
      position: "Investor"
    }
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative h-screen w-full bg-black flex flex-col items-center justify-center overflow-hidden">
        <div
          className={`flex flex-col items-center justify-center transition-all duration-1500 ${
            showHero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <img
            src="https://res.cloudinary.com/ditcmszc1/image/upload/v1769763263/Screenshot_2026-01-02_at_1.06.59_PM-Photoroom_yjuyvn_nml066.png"
            alt="Imperier Holdings"
            className="w-64 md:w-96 mb-8 animate-fade-in"
          />
          <h1
            className={`text-white text-center text-4xl md:text-6xl font-light tracking-widest transition-all duration-1000 delay-500 ${
              showHero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            IMPERIER HOLDINGS
          </h1>
        </div>
      </section>

      {/* About Us Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left - Text */}
            <div className="space-y-6 opacity-0 animate-slide-in-left">
              <h2 className="text-4xl md:text-5xl font-bold text-black">ABOUT US</h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                            Imperier Holdings is an alternative investments consultancy with a focus
              on "Emerging India" and the "New World Economy." Guided by a
              leadership advisory board, we aim to deliver multi-fold returns to our
              investors. At Imperier, we believe that investing goes beyond profits—it's
              about fostering a sustainable, equitable future.
              <br />
              <br />
              Our tagline, <i><b>Invest Beyond the Obvious</b></i>, reflects our commitment to
              seeking out transformative opportunities that others might overlook. By
              pushing boundaries and embracing innovation, we target investments
              with the power to make a positive impact.
              <br />
              <br />
              Backed by a team of seasoned professionals, we conduct rigorous
              research and due diligence, ensuring our choices align with our values
              and vision for a better world. Join us in shaping a brighter future through
              thoughtful, purpose-driven investments.              
              </p>
            </div>

            {/* Right - Image */}
            <div className="relative opacity-0 animate-slide-in-right delay-200">
              <img
                src="https://res.cloudinary.com/ditcmszc1/image/upload/v1769763263/Screenshot_2025-12-29_at_10.30.32_PM_hjdoiy_czolj8.png"
                alt="About Imperier Holdings"
                className="w-full h-auto rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="w-full bg-black">
        <video
          className="w-full h-auto"
          autoPlay
          loop
          muted
          playsInline
        >
          <source
            src="https://res.cloudinary.com/ditcmszc1/video/upload/v1769763265/imperier-video_o5o4bt_ipprls.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </section>

      {/* Portfolio Companies Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-black text-center mb-12 opacity-0 animate-fade-in-up">
            OUR PORTFOLIO
          </h2>
          <div className="flex justify-center opacity-0 animate-fade-in-up delay-200">
            <img
              src="https://res.cloudinary.com/ditcmszc1/image/upload/v1769763263/Screenshot_2025-12-29_at_10.29.40_PM_vpxyzf_ipcyzg.png"
              alt="Portfolio Companies"
              className="w-full max-w-5xl h-auto"
            />
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-6 bg-grey/20">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-black text-center mb-16 opacity-0 animate-fade-in-up">
            TESTIMONIALS
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-0">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`bg-white p-8 border border-gray-300 flex flex-col justify-between min-h-[400px] opacity-0 animate-fade-in-up delay-${(index + 1) * 100}`}
              >
                <p className="text-sm text-gray-800 leading-relaxed mb-6 flex-grow">
                  {testimonial.text}
                </p>
                <div className="mt-auto">
                  <p className="text-sm font-semibold text-black italic">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-gray-600 italic mt-1">
                    {testimonial.position}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home;

